// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lora:ital,wght@0,400;0,500;0,600;0,700;1,400;1,600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LandingBenchmark_comingSoon__hfTqR {
  position: relative;
  overflow: hidden;
  background: #f7f9fb;
  padding: 96px 32px;
}
@media (min-width: 1024px) {
  .LandingBenchmark_comingSoon__hfTqR {
    padding: 96px 48px;
  }
}
.LandingBenchmark_comingSoon__bg__\\+HLmn {
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  opacity: 0.4;
}
.LandingBenchmark_comingSoon__bgBlob1__-jlgU {
  position: absolute;
  top: -10%;
  right: -10%;
  width: 60%;
  height: 60%;
  background: linear-gradient(to bottom right, rgba(137, 245, 231, 0.2), transparent);
  filter: blur(120px);
  border-radius: 50%;
}
.LandingBenchmark_comingSoon__bgBlob2__yWKuB {
  position: absolute;
  bottom: -10%;
  left: -10%;
  width: 50%;
  height: 50%;
  background: linear-gradient(to top right, rgba(234, 221, 255, 0.1), transparent);
  filter: blur(100px);
  border-radius: 50%;
}
.LandingBenchmark_comingSoon__inner__uPxaQ {
  position: relative;
  z-index: 1;
  max-width: 1152px;
  margin: 0 auto;
}
.LandingBenchmark_comingSoon__grid__PYLRc {
  display: grid;
  grid-template-columns: 1fr;
  gap: 48px;
  align-items: center;
}
@media (min-width: 1024px) {
  .LandingBenchmark_comingSoon__grid__PYLRc {
    grid-template-columns: 7fr 5fr;
    gap: 64px;
  }
}
.LandingBenchmark_comingSoon__copy__u2Sdx {
  display: flex;
  flex-direction: column;
  gap: 40px;
}
.LandingBenchmark_comingSoon__brand__Pqcqf {
  font-family: "Lora", Georgia, serif;
  font-size: 1.5rem;
  font-style: italic;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #0f3460;
  margin: 0;
}
.LandingBenchmark_comingSoon__headlineBlock__J3eMu {
  display: flex;
  flex-direction: column;
  gap: 32px;
}
.LandingBenchmark_comingSoon__headline__BpcXO {
  font-family: "Lora", Georgia, serif;
  font-size: clamp(2.5rem, 6vw, 4.5rem);
  font-weight: 500;
  line-height: 1.1;
  letter-spacing: -0.02em;
  color: #1e293b;
  margin: 0;
}
.LandingBenchmark_comingSoon__headlineAccent__Qt\\+Np {
  font-style: italic;
  color: #0f3460;
}
.LandingBenchmark_comingSoon__lead__kLP6L {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 1.25rem;
  line-height: 1.65;
  color: #475569;
  max-width: 36rem;
  margin: 0;
}
.LandingBenchmark_comingSoon__leadStrong__m9Aos {
  color: #1e293b;
  font-weight: 600;
}
.LandingBenchmark_comingSoon__cohort__RaRzw {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 0;
}
.LandingBenchmark_comingSoon__cohortIcon__DmLkk {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  color: #0f3460;
}
.LandingBenchmark_comingSoon__cohortText__VHDaW {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  color: #6d7a77;
  margin: 0;
}
.LandingBenchmark_comingSoon__bentoWrap__I7akx {
  position: relative;
}
.LandingBenchmark_comingSoon__bento__8usXG {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
.LandingBenchmark_comingSoon__cardMetric__fZWck {
  background: #ffffff;
  border: 1px solid rgba(188, 201, 198, 0.1);
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  aspect-ratio: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.LandingBenchmark_comingSoon__cardMetricTop__r41BM {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.LandingBenchmark_comingSoon__cardMetricLabel__jOaf8 {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #0f3460;
}
.LandingBenchmark_comingSoon__cardMetricIcon__X8-q2 {
  width: 22px;
  height: 22px;
  color: rgba(13, 148, 136, 0.4);
}
.LandingBenchmark_comingSoon__cardMetricBars__EDuit {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.LandingBenchmark_comingSoon__cardMetricTrack__0-wp1 {
  height: 4px;
  background: #e0e3e5;
  border-radius: 9999px;
  overflow: hidden;
}
.LandingBenchmark_comingSoon__cardMetricFill__mFwvI {
  height: 100%;
  border-radius: 9999px;
  background: #0f3460;
}
.LandingBenchmark_comingSoon__cardMetricFillDim__ydmxg {
  opacity: 0.4;
}
.LandingBenchmark_comingSoon__cardMetricCaption__1N8zW {
  font-family: "Lora", Georgia, serif;
  font-size: 14px;
  font-style: italic;
  color: #475569;
  margin: 0;
}
.LandingBenchmark_comingSoon__cardImage__\\+7TIm {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  aspect-ratio: 4/5;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  background: #f2f4f6;
}
.LandingBenchmark_comingSoon__cardImageImg__UZRoF {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: grayscale(1);
  opacity: 0.6;
  mix-blend-mode: multiply;
}
.LandingBenchmark_comingSoon__cardImageCaption__aKkx7 {
  position: absolute;
  bottom: 16px;
  left: 16px;
  right: 16px;
}
.LandingBenchmark_comingSoon__cardImageCaptionInner__ES235 {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  padding: 12px;
  border-radius: 8px;
}
.LandingBenchmark_comingSoon__cardImageCaptionText__0giB1 {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  color: #1e293b;
  margin: 0;
}
.LandingBenchmark_comingSoon__cardWide__dHz9j {
  grid-column: 1/-1;
  background: #0f3460;
  color: #ffffff;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 10px 25px -5px rgba(13, 148, 136, 0.15);
  position: relative;
  overflow: hidden;
}
.LandingBenchmark_comingSoon__cardWideInner__GlbGc {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.LandingBenchmark_comingSoon__cardWideRow__nFbCY {
  display: flex;
  align-items: center;
  gap: 8px;
}
.LandingBenchmark_comingSoon__cardWideIcon__AFB0t {
  width: 22px;
  height: 22px;
  color: #ffffff;
}
.LandingBenchmark_comingSoon__cardWideEyebrow__1gHIh {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 12px;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  margin: 0;
}
.LandingBenchmark_comingSoon__cardWideTitle__9woy4 {
  font-family: "Lora", Georgia, serif;
  font-size: 1.5rem;
  line-height: 1.35;
  margin: 0;
}
.LandingBenchmark_comingSoon__cardWideGlow__0TBQU {
  position: absolute;
  right: -32px;
  bottom: -32px;
  width: 128px;
  height: 128px;
  background: rgba(13, 148, 136, 0.5);
  filter: blur(48px);
  border-radius: 50%;
}

.LandingBenchmark_landing__yTJEd {
  width: 100%;
  color: #191c1e;
  -webkit-font-smoothing: antialiased;
}

.LandingBenchmark_hero__YrDYf {
  position: relative;
  overflow: hidden;
  padding: 96px 32px 128px;
}
.LandingBenchmark_hero__grid__peYeC {
  max-width: 1280px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr;
  gap: 64px;
  align-items: center;
}
@media (min-width: 1024px) {
  .LandingBenchmark_hero__grid__peYeC {
    grid-template-columns: 1fr 1fr;
  }
}
.LandingBenchmark_hero__eyebrow__O-gwU {
  font-size: 12px;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: #0f3460;
  margin: 0 0 16px;
  display: block;
}
.LandingBenchmark_hero__title__5Sj7e {
  font-size: clamp(2.25rem, 5vw, 3.75rem);
  font-weight: 700;
  line-height: 1.15;
  color: #191c1e;
  margin: 0 0 24px;
}
.LandingBenchmark_hero__titleAccent__uB00a {
  font-style: italic;
  color: #0f3460;
}
.LandingBenchmark_hero__lead__X5x8H {
  font-size: 1.25rem;
  line-height: 1.6;
  color: #3d4947;
  max-width: 36rem;
  margin: 0 0 40px;
}
.LandingBenchmark_hero__actions__-XJMy {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.LandingBenchmark_hero__visual__48mgd {
  position: relative;
}
.LandingBenchmark_hero__card__tY0lb {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px rgba(15, 52, 96, 0.18);
  padding: 8px;
  transform: rotate(2deg);
  transition: transform 0.7s ease;
}
.LandingBenchmark_hero__card__tY0lb:hover {
  transform: rotate(0deg);
}
.LandingBenchmark_hero__img__lQxHc {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
.LandingBenchmark_hero__glow__1u6np {
  position: absolute;
  bottom: -40px;
  left: -40px;
  width: 192px;
  height: 192px;
  background: rgba(15, 52, 96, 0.1);
  border-radius: 50%;
  filter: blur(48px);
  pointer-events: none;
  z-index: -1;
}

.LandingBenchmark_btnPrimary__rTItq {
  border: none;
  cursor: pointer;
  background: linear-gradient(to right, #0f3460, #16213e);
  color: #ffffff;
  padding: 16px 32px;
  border-radius: 9999px;
  font-weight: 600;
  font-size: 1rem;
  box-shadow: 0 10px 25px -5px rgba(15, 52, 96, 0.25);
  transition: transform 0.2s ease;
}
.LandingBenchmark_btnPrimary__rTItq:hover {
  transform: scale(0.98);
}

.LandingBenchmark_btnSecondary__OVQ2j {
  border: none;
  cursor: pointer;
  background: #e6e8ea;
  color: #0f3460;
  padding: 16px 32px;
  border-radius: 9999px;
  font-weight: 600;
  font-size: 1rem;
  transition: background 0.2s ease;
}
.LandingBenchmark_btnSecondary__OVQ2j:hover {
  background: #e0e3e5;
}

.LandingBenchmark_pillars__sFHp3 {
  padding: 96px 32px;
}
.LandingBenchmark_pillars__grid__L7xd6 {
  max-width: 1280px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr;
  gap: 48px;
}
@media (min-width: 768px) {
  .LandingBenchmark_pillars__grid__L7xd6 {
    grid-template-columns: repeat(3, 1fr);
  }
}

.LandingBenchmark_pillar__dcvfp:hover .LandingBenchmark_pillar__iconWrap__nlkiB {
  background: #0f3460;
}
.LandingBenchmark_pillar__dcvfp:hover .LandingBenchmark_pillar__icon__yNUHZ {
  color: #ffffff;
}
.LandingBenchmark_pillar__iconWrap__nlkiB {
  width: 48px;
  height: 48px;
  background: rgba(15, 52, 96, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  transition: background 0.25s ease;
}
.LandingBenchmark_pillar__icon__yNUHZ {
  width: 26px;
  height: 26px;
  color: #0f3460;
  transition: color 0.25s ease;
}
.LandingBenchmark_pillar__title__wOpje {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 16px;
  color: #191c1e;
}
.LandingBenchmark_pillar__text__FKAAQ {
  margin: 0;
  line-height: 1.65;
  color: #3d4947;
}

.LandingBenchmark_comparison__ypXVG {
  padding: 96px 32px;
  background: #f2f4f6;
}
.LandingBenchmark_comparison__header__5gXhb {
  max-width: 1280px;
  margin: 0 auto 64px;
}
.LandingBenchmark_comparison__title__i2sGW {
  font-size: clamp(1.75rem, 4vw, 2.25rem);
  font-weight: 700;
  color: #191c1e;
  margin: 0 0 16px;
}
.LandingBenchmark_comparison__subtitle__QZVBv {
  margin: 0;
  color: #3d4947;
  max-width: 42rem;
  line-height: 1.6;
}
.LandingBenchmark_comparison__panel__9yICE {
  max-width: 1280px;
  margin: 0 auto;
  background: #ffffff;
  padding: 32px;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}
.LandingBenchmark_comparison__toolbar__xAAtW {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  margin-bottom: 40px;
  padding-bottom: 40px;
  border-bottom: 1px solid #e6e8ea;
}
.LandingBenchmark_comparison__topic__rVuDs {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: #e6e8ea;
  border-radius: 8px;
  font-size: 14px;
}
.LandingBenchmark_comparison__topicLabel__XZhtS {
  color: #3d4947;
}
.LandingBenchmark_comparison__topicValue__bimxK {
  font-weight: 700;
  color: #0f3460;
  font-style: italic;
}
.LandingBenchmark_comparison__vs__n1AZg {
  font-size: 14px;
  color: #6d7a77;
}
.LandingBenchmark_comparison__avatars__gUry1 {
  display: flex;
  margin-left: 0;
}
.LandingBenchmark_comparison__avatars__gUry1 > * + * {
  margin-left: -8px;
}
.LandingBenchmark_comparison__avatar__OZH-d {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
  color: #ffffff;
  border: 2px solid #ffffff;
  box-sizing: border-box;
}
.LandingBenchmark_comparison__metrics__iucUi {
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;
  margin-bottom: 48px;
}
@media (min-width: 768px) {
  .LandingBenchmark_comparison__metrics__iucUi {
    grid-template-columns: repeat(4, 1fr);
  }
}
.LandingBenchmark_comparison__metric__BZiFN {
  padding: 24px;
  background: #f2f4f6;
  border-radius: 8px;
}
.LandingBenchmark_comparison__metricLabel__3iSgl {
  font-size: 11px;
  letter-spacing: 0.04em;
  color: #6d7a77;
  display: block;
  margin-bottom: 8px;
}
.LandingBenchmark_comparison__metricValue__U164f {
  font-size: 1.875rem;
  font-weight: 700;
  line-height: 1.2;
}
.LandingBenchmark_comparison__metricValuePrimary__UWVOJ {
  color: #0f3460;
}
.LandingBenchmark_comparison__metricValueSecondary__oWO4y {
  color: #712ae2;
}
.LandingBenchmark_comparison__metricValueNeutral__0IvNh {
  color: #191c1e;
}
.LandingBenchmark_comparison__metricValueContainer__nlG23 {
  color: #16213e;
}
.LandingBenchmark_comparison__bars__xm\\+rH {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.LandingBenchmark_comparison__barRow__AvXvA {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.LandingBenchmark_comparison__barMeta__d79j0 {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #3d4947;
  padding: 0 4px;
}
.LandingBenchmark_comparison__track__8aC8S {
  height: 16px;
  background: #e6e8ea;
  border-radius: 9999px;
  overflow: hidden;
}
.LandingBenchmark_comparison__fill__yBbn8 {
  height: 100%;
  border-radius: 9999px;
}
.LandingBenchmark_comparison__fillPrimary__e9lR7 {
  background: #0f3460;
}
.LandingBenchmark_comparison__fillSecondary__xbQLH {
  background: #712ae2;
}
.LandingBenchmark_comparison__fillContainer__t52Nf {
  background: #16213e;
}

.LandingBenchmark_leaderboards__pyZ76 {
  padding: 48px 32px 80px;
  max-width: 960px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 48px;
}
.LandingBenchmark_leaderboards__ctaRow__GsmoX {
  display: flex;
  justify-content: center;
}

.LandingBenchmark_ctaFinal__HGdbO {
  padding: 128px 32px;
  background: #0f3460;
  text-align: center;
}
.LandingBenchmark_ctaFinal__inner__CWES4 {
  max-width: 640px;
  margin: 0 auto;
}
.LandingBenchmark_ctaFinal__title__Mqhip {
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 32px;
  line-height: 1.2;
}
.LandingBenchmark_ctaFinal__text__ECzZm {
  font-size: 1.25rem;
  line-height: 1.6;
  color: rgba(244, 255, 252, 0.92);
  margin: 0 0 48px;
}
.LandingBenchmark_ctaFinal__btn__aGU5- {
  border: none;
  cursor: pointer;
  background: #ffffff;
  color: #0f3460;
  padding: 20px 40px;
  border-radius: 9999px;
  font-weight: 700;
  font-size: 1.125rem;
  transition: transform 0.2s ease;
}
.LandingBenchmark_ctaFinal__btn__aGU5-:hover {
  transform: scale(1.05);
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/LandingBenchmark/LandingBenchmark.module.scss"],"names":[],"mappings":"AAiBA;EACE,kBAAA;EACA,gBAAA;EACA,mBAjBM;EAkBN,kBAAA;AAfF;AAiBE;EANF;IAOI,kBAAA;EAdF;AACF;AAgBE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,oBAAA;EACA,YAAA;AAdJ;AAiBE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,mFAAA;EACA,mBAAA;EACA,kBAAA;AAfJ;AAkBE;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,gFAAA;EACA,mBAAA;EACA,kBAAA;AAhBJ;AAmBE;EACE,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,cAAA;AAjBJ;AAoBE;EACE,aAAA;EACA,0BAAA;EACA,SAAA;EACA,mBAAA;AAlBJ;AAoBI;EANF;IAOI,8BAAA;IACA,SAAA;EAjBJ;AACF;AAoBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAlBJ;AAqBE;EACE,mCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAlFS;EAmFT,SAAA;AAnBJ;AAsBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AApBJ;AAuBE;EACE,mCAAA;EACA,qCAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,cApGY;EAqGZ,SAAA;AArBJ;AAwBE;EACE,kBAAA;EACA,cAxGS;AAkFb;AAyBE;EACE,uDAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAhHoB;EAiHpB,gBAAA;EACA,SAAA;AAvBJ;AA0BE;EACE,cAvHY;EAwHZ,gBAAA;AAxBJ;AA2BE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAzBJ;AA4BE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cApIS;AA0Gb;AA6BE;EACE,uDAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cA1IS;EA2IT,SAAA;AA3BJ;AA8BE;EACE,kBAAA;AA5BJ;AA+BE;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AA7BJ;AAgCE;EACE,mBAtJO;EAuJP,0CAAA;EACA,mBAAA;EACA,aAAA;EACA,yCAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AA9BJ;AAiCE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;AA/BJ;AAkCE;EACE,uDAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAlLS;AAkJb;AAmCE;EACE,WAAA;EACA,YAAA;EACA,8BAAA;AAjCJ;AAoCE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAlCJ;AAqCE;EACE,WAAA;EACA,mBA5LiB;EA6LjB,qBAAA;EACA,gBAAA;AAnCJ;AAsCE;EACE,YAAA;EACA,qBAAA;EACA,mBA3MS;AAuKb;AAuCE;EACE,YAAA;AArCJ;AAwCE;EACE,mCAAA;EACA,eAAA;EACA,kBAAA;EACA,cAvNoB;EAwNpB,SAAA;AAtCJ;AAyCE;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yCAAA;EACA,mBA3Na;AAoLjB;AA0CE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;EACA,YAAA;EACA,wBAAA;AAxCJ;AA2CE;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;AAzCJ;AA4CE;EACE,qCAAA;EACA,2BAAA;EACA,mCAAA;EACA,aAAA;EACA,kBAAA;AA1CJ;AA6CE;EACE,uDAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,cApQY;EAqQZ,SAAA;AA3CJ;AA8CE;EACE,iBAAA;EACA,mBAxQS;EAyQT,cAjQY;EAkQZ,aAAA;EACA,mBAAA;EACA,qDAAA;EACA,kBAAA;EACA,gBAAA;AA5CJ;AA+CE;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AA7CJ;AAgDE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA9CJ;AAiDE;EACE,WAAA;EACA,YAAA;EACA,cAhSe;AAiPnB;AAkDE;EACE,uDAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,SAAA;AAhDJ;AAmDE;EACE,mCAAA;EACA,iBAAA;EACA,iBAAA;EACA,SAAA;AAjDJ;AAoDE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,mCAAA;EACA,kBAAA;EACA,kBAAA;AAlDJ;;AAsEA;EACE,WAAA;EACA,cAhBW;EAiBX,mCAAA;AAnEF;;AAsEA;EACE,kBAAA;EACA,gBAAA;EACA,wBAAA;AAnEF;AAqEE;EACE,iBAAA;EACA,cAAA;EACA,aAAA;EACA,0BAAA;EACA,SAAA;EACA,mBAAA;AAnEJ;AAqEI;EARF;IASI,8BAAA;EAlEJ;AACF;AAqEE;EACE,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAxCM;EAyCN,gBAAA;EACA,cAAA;AAnEJ;AAsEE;EACE,uCAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAlDY;EAmDZ,gBAAA;AApEJ;AAuEE;EACE,kBAAA;EACA,cAvDM;AAdV;AAwEE;EACE,kBAAA;EACA,gBAAA;EACA,cA1DiB;EA2DjB,gBAAA;EACA,gBAAA;AAtEJ;AAyEE;EACE,aAAA;EACA,eAAA;EACA,SAAA;AAvEJ;AA0EE;EACE,kBAAA;AAxEJ;AA2EE;EACE,mBArEI;EAsEJ,mBAAA;EACA,oDAAA;EACA,YAAA;EACA,uBAAA;EACA,+BAAA;AAzEJ;AA2EI;EACE,uBAAA;AAzEN;AA6EE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yCAAA;AA3EJ;AA8EE;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,iCAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,WAAA;AA5EJ;;AAgFA;EACE,YAAA;EACA,eAAA;EACA,uDAAA;EACA,cA1GW;EA2GX,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,mDAAA;EACA,+BAAA;AA7EF;AA+EE;EACE,sBAAA;AA7EJ;;AAiFA;EACE,YAAA;EACA,eAAA;EACA,mBA7Ha;EA8Hb,cApIQ;EAqIR,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;AA9EF;AAgFE;EACE,mBArIc;AAuDlB;;AAkFA;EACE,kBAAA;AA/EF;AAiFE;EACE,iBAAA;EACA,cAAA;EACA,aAAA;EACA,0BAAA;EACA,SAAA;AA/EJ;AAiFI;EAPF;IAQI,qCAAA;EA9EJ;AACF;;AAmFE;EACE,mBAlKM;AAkFV;AAmFE;EACE,cA7JS;AA4Eb;AAoFE;EACE,WAAA;EACA,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iCAAA;AAlFJ;AAqFE;EACE,WAAA;EACA,YAAA;EACA,cAxLM;EAyLN,4BAAA;AAnFJ;AAsFE;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAjMY;AA6GhB;AAuFE;EACE,SAAA;EACA,iBAAA;EACA,cAnMiB;AA8GrB;;AAyFA;EACE,kBAAA;EACA,mBAvMY;AAiHd;AAwFE;EACE,iBAAA;EACA,mBAAA;AAtFJ;AAyFE;EACE,uCAAA;EACA,gBAAA;EACA,cAvNY;EAwNZ,gBAAA;AAvFJ;AA0FE;EACE,SAAA;EACA,cAzNiB;EA0NjB,gBAAA;EACA,gBAAA;AAxFJ;AA2FE;EACE,iBAAA;EACA,cAAA;EACA,mBA5NI;EA6NJ,aAAA;EACA,mBAAA;EACA,yCAAA;AAzFJ;AA4FE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;AA1FJ;AA6FE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAnPW;EAoPX,kBAAA;EACA,eAAA;AA3FJ;AA8FE;EACE,cA5PiB;AAgKrB;AA+FE;EACE,gBAAA;EACA,cApQM;EAqQN,kBAAA;AA7FJ;AAgGE;EACE,eAAA;EACA,cAtQM;AAwKV;AAiGE;EACE,aAAA;EACA,cAAA;AA/FJ;AAiGI;EACE,iBAAA;AA/FN;AAmGE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAvRI;EAwRJ,yBAAA;EACA,sBAAA;AAjGJ;AAoGE;EACE,aAAA;EACA,0BAAA;EACA,SAAA;EACA,mBAAA;AAlGJ;AAoGI;EANF;IAOI,qCAAA;EAjGJ;AACF;AAoGE;EACE,aAAA;EACA,mBA5SU;EA6SV,kBAAA;AAlGJ;AAqGE;EACE,eAAA;EACA,sBAAA;EACA,cApTM;EAqTN,cAAA;EACA,kBAAA;AAnGJ;AAsGE;EACE,mBAAA;EACA,gBAAA;EACA,gBAAA;AApGJ;AAuGE;EACE,cApUM;AA+NV;AAwGE;EACE,cAtUQ;AAgOZ;AAyGE;EACE,cA9US;AAuOb;AA0GE;EACE,cA/UgB;AAuOpB;AA2GE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAzGJ;AA4GE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA1GJ;AA6GE;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,cAhWiB;EAiWjB,cAAA;AA3GJ;AA8GE;EACE,YAAA;EACA,mBAnWW;EAoWX,qBAAA;EACA,gBAAA;AA5GJ;AA+GE;EACE,YAAA;EACA,qBAAA;AA7GJ;AAgHE;EACE,mBApXM;AAsQV;AAiHE;EACE,mBAtXQ;AAuQZ;AAkHE;EACE,mBA3XgB;AA2QpB;;AAoHA;EACE,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAjHF;AAmHE;EACE,aAAA;EACA,uBAAA;AAjHJ;;AAqHA;EACE,mBAAA;EACA,mBAhZQ;EAiZR,kBAAA;AAlHF;AAoHE;EACE,gBAAA;EACA,cAAA;AAlHJ;AAqHE;EACE,iCAAA;EACA,gBAAA;EACA,cAlZS;EAmZT,gBAAA;EACA,gBAAA;AAnHJ;AAsHE;EACE,kBAAA;EACA,gBAAA;EACA,gCAzZmB;EA0ZnB,gBAAA;AApHJ;AAuHE;EACE,YAAA;EACA,eAAA;EACA,mBAlaI;EAmaJ,cA3aM;EA4aN,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,+BAAA;AArHJ;AAuHI;EACE,sBAAA;AArHN","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Lora:ital,wght@0,400;0,500;0,600;0,700;1,400;1,600&display=swap\");\n\n// Stitch \"Coming Soon (Updated Fonts)\" — node fb15892737444db9b6f87714a1ddee00\n$cs-bg: #f7f9fb;\n$cs-on-surface: #1e293b;\n$cs-on-surface-variant: #475569;\n$cs-primary: #0f3460;\n$cs-primary-container: #0f3460;\n$cs-primary-fixed: #ffffff;\n$cs-outline: #6d7a77;\n$cs-outline-variant: #bcc9c6;\n$cs-surface-low: #f2f4f6;\n$cs-white: #ffffff;\n$cs-surface-highest: #e0e3e5;\n$cs-on-primary: #ffffff;\n$cs-secondary-fixed: #eaddff;\n\n.comingSoon {\n  position: relative;\n  overflow: hidden;\n  background: $cs-bg;\n  padding: 96px 32px;\n\n  @media (min-width: 1024px) {\n    padding: 96px 48px;\n  }\n\n  &__bg {\n    position: absolute;\n    inset: 0;\n    z-index: 0;\n    pointer-events: none;\n    opacity: 0.4;\n  }\n\n  &__bgBlob1 {\n    position: absolute;\n    top: -10%;\n    right: -10%;\n    width: 60%;\n    height: 60%;\n    background: linear-gradient(to bottom right, rgba(137, 245, 231, 0.2), transparent);\n    filter: blur(120px);\n    border-radius: 50%;\n  }\n\n  &__bgBlob2 {\n    position: absolute;\n    bottom: -10%;\n    left: -10%;\n    width: 50%;\n    height: 50%;\n    background: linear-gradient(to top right, rgba(234, 221, 255, 0.1), transparent);\n    filter: blur(100px);\n    border-radius: 50%;\n  }\n\n  &__inner {\n    position: relative;\n    z-index: 1;\n    max-width: 1152px;\n    margin: 0 auto;\n  }\n\n  &__grid {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 48px;\n    align-items: center;\n\n    @media (min-width: 1024px) {\n      grid-template-columns: 7fr 5fr;\n      gap: 64px;\n    }\n  }\n\n  &__copy {\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n  }\n\n  &__brand {\n    font-family: \"Lora\", Georgia, serif;\n    font-size: 1.5rem;\n    font-style: italic;\n    font-weight: 700;\n    letter-spacing: -0.02em;\n    color: $cs-primary;\n    margin: 0;\n  }\n\n  &__headlineBlock {\n    display: flex;\n    flex-direction: column;\n    gap: 32px;\n  }\n\n  &__headline {\n    font-family: \"Lora\", Georgia, serif;\n    font-size: clamp(2.5rem, 6vw, 4.5rem);\n    font-weight: 500;\n    line-height: 1.1;\n    letter-spacing: -0.02em;\n    color: $cs-on-surface;\n    margin: 0;\n  }\n\n  &__headlineAccent {\n    font-style: italic;\n    color: $cs-primary;\n  }\n\n  &__lead {\n    font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n    font-size: 1.25rem;\n    line-height: 1.65;\n    color: $cs-on-surface-variant;\n    max-width: 36rem;\n    margin: 0;\n  }\n\n  &__leadStrong {\n    color: $cs-on-surface;\n    font-weight: 600;\n  }\n\n  &__cohort {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 16px 0;\n  }\n\n  &__cohortIcon {\n    width: 24px;\n    height: 24px;\n    flex-shrink: 0;\n    color: $cs-primary;\n  }\n\n  &__cohortText {\n    font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n    font-size: 11px;\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 0.2em;\n    color: $cs-outline;\n    margin: 0;\n  }\n\n  &__bentoWrap {\n    position: relative;\n  }\n\n  &__bento {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n  }\n\n  &__cardMetric {\n    background: $cs-white;\n    border: 1px solid rgba(188, 201, 198, 0.1);\n    border-radius: 12px;\n    padding: 24px;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n    aspect-ratio: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n  }\n\n  &__cardMetricTop {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n  }\n\n  &__cardMetricLabel {\n    font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n    font-size: 10px;\n    font-weight: 700;\n    letter-spacing: -0.02em;\n    color: $cs-primary;\n  }\n\n  &__cardMetricIcon {\n    width: 22px;\n    height: 22px;\n    color: rgba(13, 148, 136, 0.4);\n  }\n\n  &__cardMetricBars {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  &__cardMetricTrack {\n    height: 4px;\n    background: $cs-surface-highest;\n    border-radius: 9999px;\n    overflow: hidden;\n  }\n\n  &__cardMetricFill {\n    height: 100%;\n    border-radius: 9999px;\n    background: $cs-primary;\n  }\n\n  &__cardMetricFillDim {\n    opacity: 0.4;\n  }\n\n  &__cardMetricCaption {\n    font-family: \"Lora\", Georgia, serif;\n    font-size: 14px;\n    font-style: italic;\n    color: $cs-on-surface-variant;\n    margin: 0;\n  }\n\n  &__cardImage {\n    position: relative;\n    border-radius: 12px;\n    overflow: hidden;\n    aspect-ratio: 4 / 5;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n    background: $cs-surface-low;\n  }\n\n  &__cardImageImg {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    filter: grayscale(1);\n    opacity: 0.6;\n    mix-blend-mode: multiply;\n  }\n\n  &__cardImageCaption {\n    position: absolute;\n    bottom: 16px;\n    left: 16px;\n    right: 16px;\n  }\n\n  &__cardImageCaptionInner {\n    background: rgba(255, 255, 255, 0.85);\n    backdrop-filter: blur(12px);\n    -webkit-backdrop-filter: blur(12px);\n    padding: 12px;\n    border-radius: 8px;\n  }\n\n  &__cardImageCaptionText {\n    font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n    font-size: 11px;\n    text-transform: uppercase;\n    letter-spacing: 0.02em;\n    color: $cs-on-surface;\n    margin: 0;\n  }\n\n  &__cardWide {\n    grid-column: 1 / -1;\n    background: $cs-primary;\n    color: $cs-on-primary;\n    padding: 24px;\n    border-radius: 12px;\n    box-shadow: 0 10px 25px -5px rgba(13, 148, 136, 0.15);\n    position: relative;\n    overflow: hidden;\n  }\n\n  &__cardWideInner {\n    position: relative;\n    z-index: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  &__cardWideRow {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  &__cardWideIcon {\n    width: 22px;\n    height: 22px;\n    color: $cs-primary-fixed;\n  }\n\n  &__cardWideEyebrow {\n    font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n    font-size: 12px;\n    letter-spacing: 0.2em;\n    text-transform: uppercase;\n    margin: 0;\n  }\n\n  &__cardWideTitle {\n    font-family: \"Lora\", Georgia, serif;\n    font-size: 1.5rem;\n    line-height: 1.35;\n    margin: 0;\n  }\n\n  &__cardWideGlow {\n    position: absolute;\n    right: -32px;\n    bottom: -32px;\n    width: 128px;\n    height: 128px;\n    background: rgba(13, 148, 136, 0.5);\n    filter: blur(48px);\n    border-radius: 50%;\n  }\n}\n\n// Stitch \"Minimal Desktop Landing\" tokens\n$bg-surface: #f7f9fb;\n$on-surface: #191c1e;\n$on-background: #191c1e;\n$primary: #0f3460;\n$primary-container: #16213e;\n$secondary: #712ae2;\n$on-surface-variant: #3d4947;\n$outline: #6d7a77;\n$surface-low: #f2f4f6;\n$surface-high: #e6e8ea;\n$surface-highest: #e0e3e5;\n$white: #ffffff;\n$on-primary: #ffffff;\n$on-primary-container: rgba(244, 255, 252, 0.92);\n\n.landing {\n  width: 100%;\n  color: $on-surface;\n  -webkit-font-smoothing: antialiased;\n}\n\n.hero {\n  position: relative;\n  overflow: hidden;\n  padding: 96px 32px 128px;\n\n  &__grid {\n    max-width: 1280px;\n    margin: 0 auto;\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 64px;\n    align-items: center;\n\n    @media (min-width: 1024px) {\n      grid-template-columns: 1fr 1fr;\n    }\n  }\n\n  &__eyebrow {\n    font-size: 12px;\n    letter-spacing: 0.2em;\n    text-transform: uppercase;\n    color: $primary;\n    margin: 0 0 16px;\n    display: block;\n  }\n\n  &__title {\n    font-size: clamp(2.25rem, 5vw, 3.75rem);\n    font-weight: 700;\n    line-height: 1.15;\n    color: $on-background;\n    margin: 0 0 24px;\n  }\n\n  &__titleAccent {\n    font-style: italic;\n    color: $primary;\n  }\n\n  &__lead {\n    font-size: 1.25rem;\n    line-height: 1.6;\n    color: $on-surface-variant;\n    max-width: 36rem;\n    margin: 0 0 40px;\n  }\n\n  &__actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 16px;\n  }\n\n  &__visual {\n    position: relative;\n  }\n\n  &__card {\n    background: $white;\n    border-radius: 16px;\n    box-shadow: 0 25px 50px -12px rgba(15, 52, 96, 0.18);\n    padding: 8px;\n    transform: rotate(2deg);\n    transition: transform 0.7s ease;\n\n    &:hover {\n      transform: rotate(0deg);\n    }\n  }\n\n  &__img {\n    display: block;\n    width: 100%;\n    height: auto;\n    border-radius: 8px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  }\n\n  &__glow {\n    position: absolute;\n    bottom: -40px;\n    left: -40px;\n    width: 192px;\n    height: 192px;\n    background: rgba(15, 52, 96, 0.1);\n    border-radius: 50%;\n    filter: blur(48px);\n    pointer-events: none;\n    z-index: -1;\n  }\n}\n\n.btnPrimary {\n  border: none;\n  cursor: pointer;\n  background: linear-gradient(to right, $primary, $primary-container);\n  color: $on-primary;\n  padding: 16px 32px;\n  border-radius: 9999px;\n  font-weight: 600;\n  font-size: 1rem;\n  box-shadow: 0 10px 25px -5px rgba(15, 52, 96, 0.25);\n  transition: transform 0.2s ease;\n\n  &:hover {\n    transform: scale(0.98);\n  }\n}\n\n.btnSecondary {\n  border: none;\n  cursor: pointer;\n  background: $surface-high;\n  color: $primary;\n  padding: 16px 32px;\n  border-radius: 9999px;\n  font-weight: 600;\n  font-size: 1rem;\n  transition: background 0.2s ease;\n\n  &:hover {\n    background: $surface-highest;\n  }\n}\n\n.pillars {\n  padding: 96px 32px;\n\n  &__grid {\n    max-width: 1280px;\n    margin: 0 auto;\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 48px;\n\n    @media (min-width: 768px) {\n      grid-template-columns: repeat(3, 1fr);\n    }\n  }\n}\n\n.pillar {\n  &:hover &__iconWrap {\n    background: $primary;\n  }\n\n  &:hover &__icon {\n    color: $on-primary;\n  }\n\n  &__iconWrap {\n    width: 48px;\n    height: 48px;\n    background: rgba(15, 52, 96, 0.1);\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 24px;\n    transition: background 0.25s ease;\n  }\n\n  &__icon {\n    width: 26px;\n    height: 26px;\n    color: $primary;\n    transition: color 0.25s ease;\n  }\n\n  &__title {\n    font-size: 1.5rem;\n    font-weight: 600;\n    margin: 0 0 16px;\n    color: $on-background;\n  }\n\n  &__text {\n    margin: 0;\n    line-height: 1.65;\n    color: $on-surface-variant;\n  }\n}\n\n.comparison {\n  padding: 96px 32px;\n  background: $surface-low;\n\n  &__header {\n    max-width: 1280px;\n    margin: 0 auto 64px;\n  }\n\n  &__title {\n    font-size: clamp(1.75rem, 4vw, 2.25rem);\n    font-weight: 700;\n    color: $on-background;\n    margin: 0 0 16px;\n  }\n\n  &__subtitle {\n    margin: 0;\n    color: $on-surface-variant;\n    max-width: 42rem;\n    line-height: 1.6;\n  }\n\n  &__panel {\n    max-width: 1280px;\n    margin: 0 auto;\n    background: $white;\n    padding: 32px;\n    border-radius: 12px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n  }\n\n  &__toolbar {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 16px;\n    margin-bottom: 40px;\n    padding-bottom: 40px;\n    border-bottom: 1px solid $surface-high;\n  }\n\n  &__topic {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 16px;\n    background: $surface-high;\n    border-radius: 8px;\n    font-size: 14px;\n  }\n\n  &__topicLabel {\n    color: $on-surface-variant;\n  }\n\n  &__topicValue {\n    font-weight: 700;\n    color: $primary;\n    font-style: italic;\n  }\n\n  &__vs {\n    font-size: 14px;\n    color: $outline;\n  }\n\n  &__avatars {\n    display: flex;\n    margin-left: 0;\n\n    > * + * {\n      margin-left: -8px;\n    }\n  }\n\n  &__avatar {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 10px;\n    font-weight: 700;\n    color: $white;\n    border: 2px solid $white;\n    box-sizing: border-box;\n  }\n\n  &__metrics {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 32px;\n    margin-bottom: 48px;\n\n    @media (min-width: 768px) {\n      grid-template-columns: repeat(4, 1fr);\n    }\n  }\n\n  &__metric {\n    padding: 24px;\n    background: $surface-low;\n    border-radius: 8px;\n  }\n\n  &__metricLabel {\n    font-size: 11px;\n    letter-spacing: 0.04em;\n    color: $outline;\n    display: block;\n    margin-bottom: 8px;\n  }\n\n  &__metricValue {\n    font-size: 1.875rem;\n    font-weight: 700;\n    line-height: 1.2;\n  }\n\n  &__metricValuePrimary {\n    color: $primary;\n  }\n\n  &__metricValueSecondary {\n    color: $secondary;\n  }\n\n  &__metricValueNeutral {\n    color: $on-surface;\n  }\n\n  &__metricValueContainer {\n    color: $primary-container;\n  }\n\n  &__bars {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n  }\n\n  &__barRow {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  &__barMeta {\n    display: flex;\n    justify-content: space-between;\n    font-size: 12px;\n    color: $on-surface-variant;\n    padding: 0 4px;\n  }\n\n  &__track {\n    height: 16px;\n    background: $surface-high;\n    border-radius: 9999px;\n    overflow: hidden;\n  }\n\n  &__fill {\n    height: 100%;\n    border-radius: 9999px;\n  }\n\n  &__fillPrimary {\n    background: $primary;\n  }\n\n  &__fillSecondary {\n    background: $secondary;\n  }\n\n  &__fillContainer {\n    background: $primary-container;\n  }\n}\n\n.leaderboards {\n  padding: 48px 32px 80px;\n  max-width: 960px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 48px;\n\n  &__ctaRow {\n    display: flex;\n    justify-content: center;\n  }\n}\n\n.ctaFinal {\n  padding: 128px 32px;\n  background: $primary;\n  text-align: center;\n\n  &__inner {\n    max-width: 640px;\n    margin: 0 auto;\n  }\n\n  &__title {\n    font-size: clamp(2rem, 4vw, 3rem);\n    font-weight: 700;\n    color: $on-primary;\n    margin: 0 0 32px;\n    line-height: 1.2;\n  }\n\n  &__text {\n    font-size: 1.25rem;\n    line-height: 1.6;\n    color: $on-primary-container;\n    margin: 0 0 48px;\n  }\n\n  &__btn {\n    border: none;\n    cursor: pointer;\n    background: $white;\n    color: $primary;\n    padding: 20px 40px;\n    border-radius: 9999px;\n    font-weight: 700;\n    font-size: 1.125rem;\n    transition: transform 0.2s ease;\n\n    &:hover {\n      transform: scale(1.05);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"comingSoon": `LandingBenchmark_comingSoon__hfTqR`,
	"comingSoon__bg": `LandingBenchmark_comingSoon__bg__+HLmn`,
	"comingSoon__bgBlob1": `LandingBenchmark_comingSoon__bgBlob1__-jlgU`,
	"comingSoon__bgBlob2": `LandingBenchmark_comingSoon__bgBlob2__yWKuB`,
	"comingSoon__inner": `LandingBenchmark_comingSoon__inner__uPxaQ`,
	"comingSoon__grid": `LandingBenchmark_comingSoon__grid__PYLRc`,
	"comingSoon__copy": `LandingBenchmark_comingSoon__copy__u2Sdx`,
	"comingSoon__brand": `LandingBenchmark_comingSoon__brand__Pqcqf`,
	"comingSoon__headlineBlock": `LandingBenchmark_comingSoon__headlineBlock__J3eMu`,
	"comingSoon__headline": `LandingBenchmark_comingSoon__headline__BpcXO`,
	"comingSoon__headlineAccent": `LandingBenchmark_comingSoon__headlineAccent__Qt+Np`,
	"comingSoon__lead": `LandingBenchmark_comingSoon__lead__kLP6L`,
	"comingSoon__leadStrong": `LandingBenchmark_comingSoon__leadStrong__m9Aos`,
	"comingSoon__cohort": `LandingBenchmark_comingSoon__cohort__RaRzw`,
	"comingSoon__cohortIcon": `LandingBenchmark_comingSoon__cohortIcon__DmLkk`,
	"comingSoon__cohortText": `LandingBenchmark_comingSoon__cohortText__VHDaW`,
	"comingSoon__bentoWrap": `LandingBenchmark_comingSoon__bentoWrap__I7akx`,
	"comingSoon__bento": `LandingBenchmark_comingSoon__bento__8usXG`,
	"comingSoon__cardMetric": `LandingBenchmark_comingSoon__cardMetric__fZWck`,
	"comingSoon__cardMetricTop": `LandingBenchmark_comingSoon__cardMetricTop__r41BM`,
	"comingSoon__cardMetricLabel": `LandingBenchmark_comingSoon__cardMetricLabel__jOaf8`,
	"comingSoon__cardMetricIcon": `LandingBenchmark_comingSoon__cardMetricIcon__X8-q2`,
	"comingSoon__cardMetricBars": `LandingBenchmark_comingSoon__cardMetricBars__EDuit`,
	"comingSoon__cardMetricTrack": `LandingBenchmark_comingSoon__cardMetricTrack__0-wp1`,
	"comingSoon__cardMetricFill": `LandingBenchmark_comingSoon__cardMetricFill__mFwvI`,
	"comingSoon__cardMetricFillDim": `LandingBenchmark_comingSoon__cardMetricFillDim__ydmxg`,
	"comingSoon__cardMetricCaption": `LandingBenchmark_comingSoon__cardMetricCaption__1N8zW`,
	"comingSoon__cardImage": `LandingBenchmark_comingSoon__cardImage__+7TIm`,
	"comingSoon__cardImageImg": `LandingBenchmark_comingSoon__cardImageImg__UZRoF`,
	"comingSoon__cardImageCaption": `LandingBenchmark_comingSoon__cardImageCaption__aKkx7`,
	"comingSoon__cardImageCaptionInner": `LandingBenchmark_comingSoon__cardImageCaptionInner__ES235`,
	"comingSoon__cardImageCaptionText": `LandingBenchmark_comingSoon__cardImageCaptionText__0giB1`,
	"comingSoon__cardWide": `LandingBenchmark_comingSoon__cardWide__dHz9j`,
	"comingSoon__cardWideInner": `LandingBenchmark_comingSoon__cardWideInner__GlbGc`,
	"comingSoon__cardWideRow": `LandingBenchmark_comingSoon__cardWideRow__nFbCY`,
	"comingSoon__cardWideIcon": `LandingBenchmark_comingSoon__cardWideIcon__AFB0t`,
	"comingSoon__cardWideEyebrow": `LandingBenchmark_comingSoon__cardWideEyebrow__1gHIh`,
	"comingSoon__cardWideTitle": `LandingBenchmark_comingSoon__cardWideTitle__9woy4`,
	"comingSoon__cardWideGlow": `LandingBenchmark_comingSoon__cardWideGlow__0TBQU`,
	"landing": `LandingBenchmark_landing__yTJEd`,
	"hero": `LandingBenchmark_hero__YrDYf`,
	"hero__grid": `LandingBenchmark_hero__grid__peYeC`,
	"hero__eyebrow": `LandingBenchmark_hero__eyebrow__O-gwU`,
	"hero__title": `LandingBenchmark_hero__title__5Sj7e`,
	"hero__titleAccent": `LandingBenchmark_hero__titleAccent__uB00a`,
	"hero__lead": `LandingBenchmark_hero__lead__X5x8H`,
	"hero__actions": `LandingBenchmark_hero__actions__-XJMy`,
	"hero__visual": `LandingBenchmark_hero__visual__48mgd`,
	"hero__card": `LandingBenchmark_hero__card__tY0lb`,
	"hero__img": `LandingBenchmark_hero__img__lQxHc`,
	"hero__glow": `LandingBenchmark_hero__glow__1u6np`,
	"btnPrimary": `LandingBenchmark_btnPrimary__rTItq`,
	"btnSecondary": `LandingBenchmark_btnSecondary__OVQ2j`,
	"pillars": `LandingBenchmark_pillars__sFHp3`,
	"pillars__grid": `LandingBenchmark_pillars__grid__L7xd6`,
	"pillar": `LandingBenchmark_pillar__dcvfp`,
	"pillar__iconWrap": `LandingBenchmark_pillar__iconWrap__nlkiB`,
	"pillar__icon": `LandingBenchmark_pillar__icon__yNUHZ`,
	"pillar__title": `LandingBenchmark_pillar__title__wOpje`,
	"pillar__text": `LandingBenchmark_pillar__text__FKAAQ`,
	"comparison": `LandingBenchmark_comparison__ypXVG`,
	"comparison__header": `LandingBenchmark_comparison__header__5gXhb`,
	"comparison__title": `LandingBenchmark_comparison__title__i2sGW`,
	"comparison__subtitle": `LandingBenchmark_comparison__subtitle__QZVBv`,
	"comparison__panel": `LandingBenchmark_comparison__panel__9yICE`,
	"comparison__toolbar": `LandingBenchmark_comparison__toolbar__xAAtW`,
	"comparison__topic": `LandingBenchmark_comparison__topic__rVuDs`,
	"comparison__topicLabel": `LandingBenchmark_comparison__topicLabel__XZhtS`,
	"comparison__topicValue": `LandingBenchmark_comparison__topicValue__bimxK`,
	"comparison__vs": `LandingBenchmark_comparison__vs__n1AZg`,
	"comparison__avatars": `LandingBenchmark_comparison__avatars__gUry1`,
	"comparison__avatar": `LandingBenchmark_comparison__avatar__OZH-d`,
	"comparison__metrics": `LandingBenchmark_comparison__metrics__iucUi`,
	"comparison__metric": `LandingBenchmark_comparison__metric__BZiFN`,
	"comparison__metricLabel": `LandingBenchmark_comparison__metricLabel__3iSgl`,
	"comparison__metricValue": `LandingBenchmark_comparison__metricValue__U164f`,
	"comparison__metricValuePrimary": `LandingBenchmark_comparison__metricValuePrimary__UWVOJ`,
	"comparison__metricValueSecondary": `LandingBenchmark_comparison__metricValueSecondary__oWO4y`,
	"comparison__metricValueNeutral": `LandingBenchmark_comparison__metricValueNeutral__0IvNh`,
	"comparison__metricValueContainer": `LandingBenchmark_comparison__metricValueContainer__nlG23`,
	"comparison__bars": `LandingBenchmark_comparison__bars__xm+rH`,
	"comparison__barRow": `LandingBenchmark_comparison__barRow__AvXvA`,
	"comparison__barMeta": `LandingBenchmark_comparison__barMeta__d79j0`,
	"comparison__track": `LandingBenchmark_comparison__track__8aC8S`,
	"comparison__fill": `LandingBenchmark_comparison__fill__yBbn8`,
	"comparison__fillPrimary": `LandingBenchmark_comparison__fillPrimary__e9lR7`,
	"comparison__fillSecondary": `LandingBenchmark_comparison__fillSecondary__xbQLH`,
	"comparison__fillContainer": `LandingBenchmark_comparison__fillContainer__t52Nf`,
	"leaderboards": `LandingBenchmark_leaderboards__pyZ76`,
	"leaderboards__ctaRow": `LandingBenchmark_leaderboards__ctaRow__GsmoX`,
	"ctaFinal": `LandingBenchmark_ctaFinal__HGdbO`,
	"ctaFinal__inner": `LandingBenchmark_ctaFinal__inner__CWES4`,
	"ctaFinal__title": `LandingBenchmark_ctaFinal__title__Mqhip`,
	"ctaFinal__text": `LandingBenchmark_ctaFinal__text__ECzZm`,
	"ctaFinal__btn": `LandingBenchmark_ctaFinal__btn__aGU5-`
};
export default ___CSS_LOADER_EXPORT___;
